export const OPEN_WITHDRAWN_STATUSES = ['RESERVED', 'ISSUED'];

export const WITHDRAWN_STATUS_LABELS = {
  RESERVED: 'Rezervisano',
  ISSUED: 'Izdata',
  RETURNED: 'Vraćeno',
  USED: 'Iskorišćeno',
  CANCELLED: 'Otkazano',
};

export function getWithdrawnMovementLabel(movement) {
  if (!movement) return 'Stavka';
  if (movement.stockItem?.name) {
    const code = movement.stockItem.code || movement.stockItem.itemCode;
    return `${movement.stockItem.name}${code ? ` (${code})` : ''}`;
  }
  if (movement.sourceType === 'SPARE_PART' && movement.sparePartId) {
    const sp = typeof movement.sparePartId === 'object' ? movement.sparePartId : null;
    return sp ? `${sp.name}${sp.code ? ` (${sp.code})` : ''}` : 'Rezervni deo';
  }
  if (movement.itemId) {
    const item = typeof movement.itemId === 'object' ? movement.itemId : null;
    return item ? `${item.name}${item.itemCode ? ` (${item.itemCode})` : ''}` : 'Artikal';
  }
  return 'Stavka';
}

export function getWithdrawnMovementSourceLabel(movement) {
  if (movement?.sourceType === 'SPARE_PART') return 'Rez. delovi';
  const item = typeof movement?.itemId === 'object' ? movement.itemId : null;
  if (item?.stockKind === 'ASSET') return 'Inventar';
  return 'Magacin';
}

export function getOpenWithdrawnMovements(movements) {
  return (movements || []).filter((m) => OPEN_WITHDRAWN_STATUSES.includes(m.status));
}
